import axios from "axios";
import { API_URL } from "constants";

export const post = async (companyId, payload) => {
  const url = `${API_URL}/${companyId}/click-to-sign`;
  return axios.post(url, payload).then((response) => response.data);
};

export const addSigner = async (companyId, payload) => {
  const url = `${API_URL}/${companyId}/click-to-sign/add-signer`;
  return axios.post(url, payload).then((response) => response.data);
};

export const declineSignRequest = async (companyId, payload) => {
  const url = `${API_URL}/${companyId}/click-to-sign/decline-sign-request`;
  return axios.post(url, payload).then((response) => response.data);
};

export const uploadClickToSign = async (companyId, payload) => {
  const url = `${API_URL}/${companyId}/click-to-sign/assign`;
  return axios.post(url, payload).then((response) => response.data);
};

export const removeClickSigner = async (companyId, payload) => {
  const url = `${API_URL}/${companyId}/click-to-sign/remove-signer`;
  return axios.post(url, payload).then((response) => response.data);
};
